import React from 'react';
import Chart from '../chart';
import { legend, mergeOptions } from '../utils/commons';
var donutOptions = _ref => {
  var {
    theme
  } = _ref;
  return {
    chart: {
      type: 'pie'
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      pie: {
        borderWidth: 0,
        innerSize: '80%',
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        size: '50%',
        states: {
          inactive: {
            opacity: 1
          },
          hover: {
            halo: {
              size: 6
            },
            lineWidthPlus: 0
          }
        }
      }
    },
    legend: legend({
      theme
    }),
    title: {
      margin: undefined,
      style: {
        fontSize: theme.typography.size9,
        lineHeight: theme.typography.lineHeight9
      },
      verticalAlign: 'middle',
      y: 25
    },
    subtitle: {
      style: {
        fontSize: theme.typography.size2,
        lineHeight: theme.typography.lineHeight3
      },
      text: undefined,
      verticalAlign: 'middle',
      y: 40
    },
    tooltip: {
      useHTML: true,
      backgroundColor: theme.colorChartTooltipBackground,
      borderRadius: 10,
      headerFormat: "<span style=\"font-family: ".concat(theme.typography.family0, "; font-size: ").concat(theme.typography.size1, "; line-height: ").concat(theme.typography.lineHeight2, ";\">{point.key}</span><br/>"),
      pointFormat: "<span style=\"font-family: ".concat(theme.typography.family0, "; font-size: ").concat(theme.typography.size0, "; line-height: ").concat(theme.typography.lineHeight1, "\">{series.name}: {point.y}</span>"),
      style: {
        color: theme.colorChartTooltipForeground
      }
    }
  };
};
var Donut = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  var {
    options,
    theme
  } = _ref2;
  var chartOptions = React.useMemo(() => {
    var mergedOptions = mergeOptions(donutOptions({
      theme
    }), options);
    var newOptions = mergedOptions;
    newOptions.chart.type = 'pie';
    return newOptions;
  }, [options, theme]);
  return /*#__PURE__*/React.createElement(Chart, {
    immutable: true,
    options: chartOptions,
    ref: ref,
    theme: theme
  });
});
Donut.displayName = 'Donut';
export default Donut;